import PropTypes from 'prop-types'

const { shape } = PropTypes

const PermissionShape = shape({
  // Data
})

export { PermissionShape }
